module.exports = __webpack_public_path__ + "img/Equestrian.9f68ef27.png";